var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBetRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.31 14c-5.52 0-10 4.48-10 10v.226l.69-.69a1 1 0 0 1 1.415 1.413l-2.354 2.354a1 1 0 0 1-1.414 0l-2.354-2.354a1 1 0 1 1 1.414-1.414l.603.603V24c0-6.624 5.376-12 12-12s12 5.376 12 12-5.376 12-12 12a11.95 11.95 0 0 1-8.353-3.385 1 1 0 0 1 1.394-1.434A9.95 9.95 0 0 0 25.31 34c5.52 0 10-4.48 10-10s-4.48-10-10-10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.782 18.951a1 1 0 0 0-2 0v6.358a1 1 0 0 0 .515.874l4.4 2.442a1 1 0 1 0 .97-1.748l-3.885-2.156z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBetRecord);
export default __webpack_public_path__ + "static/media/IcoBetRecord.0c9d39046b6b9ad4f7d08cf314baa870.svg";
export { ForwardRef as ReactComponent };